"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestService = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var page_1 = require("../page/page");
var index_1 = require("./index");
var batch_observable_1 = require("./util/batch.observable");
var ObservableFetchableStore = /** @class */ (function () {
    function ObservableFetchableStore() {
    }
    ObservableFetchableStore.prototype.setIsFetching = function (isFetching) {
        this.isFetching = isFetching;
    };
    ObservableFetchableStore.prototype.setValue = function (value, lastFetch) {
        this.value = value;
        this.lastFetch = lastFetch;
        this.isFetching = false;
    };
    ObservableFetchableStore.prototype.setError = function (error) {
        this.error = error;
        this.isFetching = false;
    };
    tslib_1.__decorate([
        batch_observable_1.batchObservable
    ], ObservableFetchableStore.prototype, "value", void 0);
    tslib_1.__decorate([
        batch_observable_1.batchObservable
    ], ObservableFetchableStore.prototype, "error", void 0);
    tslib_1.__decorate([
        batch_observable_1.batchObservable
    ], ObservableFetchableStore.prototype, "isFetching", void 0);
    tslib_1.__decorate([
        batch_observable_1.batchObservable
    ], ObservableFetchableStore.prototype, "lastFetch", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ObservableFetchableStore.prototype, "setIsFetching", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ObservableFetchableStore.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ObservableFetchableStore.prototype, "setError", null);
    return ObservableFetchableStore;
}());
var IkeRestService = /** @class */ (function () {
    function IkeRestService() {
        this.__priority = 10; // After config and log service
    }
    IkeRestService.prototype.init = function () {
        core_shared_1.IkeRest.FetchableStore = ObservableFetchableStore;
        var config = index_1.Services.Config.config;
        this.rest = core_shared_1.IkeRest.create(config, {
            log: index_1.Services.Log.Logger
        });
        this.rest.onError(core_shared_1.IkeRequestErrorType.INVALID_SESSION, this.reauthenticateUser);
        this.rest.onError(core_shared_1.IkeRequestErrorType.LICENSE_REQUIRED, this.handleNoLicenseResponse);
    };
    IkeRestService.prototype.reauthenticateUser = function () {
        index_1.Services.Route.go(page_1.IkePageName.logout);
    };
    IkeRestService.prototype.handleNoLicenseResponse = function () {
        index_1.Services.License.hasNoLicense = true;
    };
    return IkeRestService;
}());
exports.IkeRestService = IkeRestService;
//# sourceMappingURL=ike.rest.service.js.map